module.exports = __webpack_public_path__ + "img/pic_bg@2x.76037f4e.png";